export const house =
  'M215.6,230.4V128l40.4-0.5L127.7,25.6L0,127.5h40.4v102.9H108v-73.7H148v73.7H215.6z'
